import 'd3-format'
import * as d3 from 'd3'
import SingleDataViewerComponent from '../../common/SingleDataViewer/SingleDataViewerComponent'
import PropTypes from 'prop-types'

const UniqueAddresses = ({
  state,
  uniqueAddresses,
  loadingAggregations,
  outreachSimulationTitle = '',
  percentage = ''
}) => {
  UniqueAddresses.propTypes = {
    state: PropTypes.string,
    uniqueAddresses: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    loadingAggregations: PropTypes.bool,
    outreachSimulationTitle: PropTypes.string,
    percentage: PropTypes.string
  }
  const title = outreachSimulationTitle || `Selected ${state} Unique Addresses`
  function getUniqueAddresses() {
    if (typeof uniqueAddresses === 'string') {
      return uniqueAddresses
    }
    return uniqueAddresses >= 0 ? d3.format('.4~s')(uniqueAddresses) : '---'
  }

  return (
    <SingleDataViewerComponent
      icon={outreachSimulationTitle === ''}
      text={title}
      value={getUniqueAddresses()}
      loading={loadingAggregations}
      percent={percentage}
    />
  )
}

export default UniqueAddresses
